import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { useSetTitle } from '@/stores/title-context';

import { PipelineBoardPage } from '@/pages/crm/pipeline/PipelineBoardPage';
import { boardSearchSchema } from '@/pages/crm/pipeline/boardSearch';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

function PipelineBoardRoute() {
	const { t } = useLingui();
	const { pipelineId } = Route.useParams();
	useSetTitle(t`Pipeline`);
	return <PipelineBoardPage pipelineId={pipelineId} />;
}

export const Route = createFileRoute('/_authenticated/_app/crm/pipeline/$pipelineId')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['deals.read.own', 'deals.read.all'], redirectTo: '/dashboard' }),
	component: PipelineBoardRoute,
	validateSearch: boardSearchSchema,
});
